// components/Onboarding/OnboardingHeader.jsx — NEW
// No stellarnav, no jQuery, no DOM manipulation outside React's control.
// Onboarding pages are authenticated, post-login steps — they don't need
// the public site's full marketing nav (Login/Sign-Up, Blog, For
// providers), just the logo so the user knows where they are.
import React from 'react';
import { Link } from 'react-router-dom';

const OnboardingHeader = () => {
  return (
    <div className="onboarding-header" style={{
      padding: '18px 24px',
      borderBottom: '1px solid #EEE',
      background: '#fff',
    }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center' }}>
        <img src="/images/logo.jpg" alt="Future Family" style={{ height: 32, width: 'auto' }} />
      </Link>
    </div>
  );
};

export default OnboardingHeader;